import { ReactElement } from "react"

interface IDisplayIfElseProps {
    condition: boolean
    displayIfTrue: ReactElement
    displayIfFalse: ReactElement
}

/**
 * Returns displayIfTrue if condition is true, otherwise returns displayIfFalse
 */
const DisplayIfElse = ({
    condition,
    displayIfTrue,
    displayIfFalse,
}: IDisplayIfElseProps): ReactElement =>
    condition ? displayIfTrue : displayIfFalse

export default DisplayIfElse
